import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';
import clearFileProviderItems from './clearFileProviderItems';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import updateFileProviderItems from './updateFileProviderItems';
import { logUsage } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';
import getFileProviderItemsRequestCount, {
    incrementGetFileProviderItemsRequestCount,
} from './helpers/getFileProviderItemsRequestCount';

// TODO: bug 30332 make this an orcestrator and update other filepicker actions to use satchel 3.0
export default mutatorAction(
    'changeListViewItemsSorting',
    async function changeListViewItemsSorting(
        sortType: AttachmentItemsSortColumn | null,
        viewState: FilePickerPanelViewState,
        customSort?: (
            items: FileProviderItemViewState[],
            sortAsc: boolean
        ) => FileProviderItemViewState[]
    ) {
        if (sortType === null) {
            return;
        }

        let sortOrder = AttachmentItemsSortOrder.Ascending;

        if (viewState.filePickerViewState.columnSorting.SortColumn === sortType) {
            sortOrder =
                viewState.filePickerViewState.columnSorting.SortOrder ===
                AttachmentItemsSortOrder.Descending
                    ? AttachmentItemsSortOrder.Ascending
                    : AttachmentItemsSortOrder.Descending;
        }

        viewState.filePickerViewState.columnSorting.SortColumn = sortType;
        viewState.filePickerViewState.columnSorting.SortOrder = sortOrder;

        logUsage('FPAttachmentsSort', [sortType, sortOrder]);
        incrementGetFileProviderItemsRequestCount();

        if (customSort) {
            const requestCount = getFileProviderItemsRequestCount();
            const sortedItems = customSort(
                viewState.filePickerViewState.fileProviderItems,
                sortOrder === AttachmentItemsSortOrder.Ascending
            );

            clearFileProviderItems(viewState.filePickerViewState);

            // We break the thread to re-render the list view in an empty state. This is to fix a bug where some items were not getting
            // cleared when sorting, causing duplicates in the display.
            await setTimeout(null, 0);
            updateFileProviderItems(sortedItems, viewState, requestCount);
        } else {
            clearFileProviderItems(viewState.filePickerViewState);
            loadMoreItemsForSelectedProvider(viewState);
        }
    }
);
